import PropTypes from 'prop-types';
// @mui
import { Box, Tooltip } from '@mui/material';
import { styled } from '@mui/material/styles';
// hooks
import useAuth from '../../../hooks/useAuth';
// routes
// components
import CompanyAvatar from '../../../components/CompanyAvatar';
import TextMaxLine from '../../../components/TextMaxLine';

// ----------------------------------------------------------------------

const RootStyle = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(2, 2.5),
  borderRadius: Number(theme.shape.borderRadius) * 1.5,
  backgroundColor: theme.palette.grey[500_12],
  transition: theme.transitions.create('opacity', {
    duration: theme.transitions.duration.shorter,
  }),
}));

// ----------------------------------------------------------------------

NavbarAccount.propTypes = {
  isCollapse: PropTypes.bool,
};

export default function NavbarAccount({ isCollapse }) {
  const { user } = useAuth();

  return (
    <RootStyle
      sx={{
        ...(isCollapse && {
          bgcolor: 'transparent',
        }),
      }}
    >
      <CompanyAvatar />

      <Box
        sx={{
          ml: 2,
          transition: (theme) =>
            theme.transitions.create('width', {
              duration: theme.transitions.duration.shorter,
            }),
          ...(isCollapse && {
            ml: 0,
            width: 0,
          }),
        }}
      >
        <Tooltip title={user?.company?.name}>
          <TextMaxLine variant="subtitle2" line={1}>
            {user?.company?.name}
          </TextMaxLine>
        </Tooltip>

        <Tooltip title={user?.company?.name}>
          <TextMaxLine variant="body2" line={1} sx={{ color: 'text.secondary' }}>
            {user?.name}
          </TextMaxLine>
        </Tooltip>
      </Box>
    </RootStyle>
  );
}
